<template>
  <div class="chatbot-page">
    <!-- En-tête avec dégradé, sans la navigation en double -->
    <header class="header">
      <div class="header-content">
        <h1 class="main-title">Nos solutions de chatbots intelligents</h1>
        <p class="subtitle">Chatbots augmentés par l'IA : L'intelligence conversationnelle au service de votre entreprise</p>
      </div>
    </header>

    <div class="content-container">
      <!-- Introduction -->
      <section class="card intro-card">
        <div class="card-content">
          <h2 class="section-title">Chatbot IA : Des solutions de dialogue automatisé efficaces dans tout type de contexte professionnel</h2>
          <div class="text-and-illustration">
            <div class="text-content">
              <p>
                Face à la digitalisation croissante de l'expérience client, 
                notre agence développe des solutions conversationnelles sur mesure, adaptées aux besoins de votre entreprise. 
                Nous concevons et déployons des chatbots intelligents qui améliorent concrètement vos interactions en ligne. 
                Notre approche personnalisée permet d'optimiser votre service client et vos processus internes avec des outils 
                conversationnels efficaces et évolutifs, conçus selon les standards techniques actuels.
              </p>
            </div>
            <div class="youtube-container">
              <iframe
                style="width: 100%; height: 100%; border: none; border-radius: 15px;"
                src="https://www.youtube.com/embed/27iyosTR_mk"
                title="Présentation de nos solutions Chatbot IA"
                frameborder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowfullscreen>
              </iframe>
            </div>
          </div>
        </div>
      </section>

      <!-- Qu'est-ce qu'un chatbot - Avec l'image intégrée à droite -->
      <section class="card what-is-card">
        <div class="card-content">
          <h2 class="section-title">Qu'est-ce qu'un Chatbot ?</h2>
          <div class="text-and-illustration">
            <div class="text-content">
              <p>
                Un chatbot est un programme informatique conçu pour simuler une conversation avec un
                utilisateur humain. Utilisant l'intelligence artificielle et le traitement du langage naturel,
                nos chatbots peuvent comprendre les demandes, fournir des réponses pertinentes et assister
                les utilisateurs dans diverses tâches. Ils offrent une interface conversationnelle accessible 24/7,
                réduisent les coûts opérationnels et améliorent significativement l'expérience client.
                Les chatbots modernes vont bien au-delà des simples réponses automatisées : ils apprennent,
                s'adaptent et évoluent pour offrir des interactions toujours plus naturelles et pertinentes.
              </p>
            </div>
            <div class="chatbot-illustration">
              <img src="/img/chatbot.svg" alt="Illustration d'un chatbot interactif" class="chatbot-image" />
            </div>
          </div>
        </div>
      </section>

      <!-- Pourquoi choisir nos chatbots -->
      <section class="card why-choose-card">
        <div class="card-content">
          <h2 class="section-title">Pourquoi nous choisir pour développer vos chatbots ?</h2>
          <div class="text-content">
            <p>
              Vous recherchez une solution conversationnelle qui améliore concrètement
              votre relation client et optimise vos processus internes ? 
              Nos chatbots sont développés avec des technologies éprouvées et 
              adaptés précisément à vos besoins métiers. Vous bénéficiez d'outils 
              performants qui répondent aux exigences actuelles de votre secteur, 
              avec un retour sur investissement mesurable pour votre entreprise.
            </p>
            <p><br>
              <a href="https://www.graine-digitale.fr/demo/chatbot/" target="_blank" 
                style="display: block; width: fit-content; margin: 0 auto; background-color: #7c3aed1a; color: inherit; padding: 10px; border-radius: 9999px;">
                <strong>Testez ici notre chatbot de démonstration</strong>
              </a><br>
              <img src="/img/chatbot-demo.png" alt="Chatbot Demo" style="display: block; margin: auto;" />
            </p>
          </div>

        </div>
      </section>

      <!-- Avantages (Cartes) -->
      <div class="advantages-grid">
        <!-- Avantage 1 -->
        <div class="advantage-card">
          <div class="advantage-number">1</div>
          <h3 class="advantage-title">Amélioration de l'expérience Client</h3>
          <p class="advantage-description">
            Vos chatbots seront conçus pour répondre instantanément aux besoins de vos clients, offrir un
            support 24/7 et guider efficacement les utilisateurs tout au long de leur parcours. Ils réduiront
            les temps d'attente, augmenteront la satisfaction client et permettront des interactions personnalisées
            à grande échelle.
          </p>
        </div>

        <!-- Avantage 2 -->
        <div class="advantage-card">
          <div class="advantage-number">2</div>
          <h3 class="advantage-title">Optimisation des processus internes</h3>
          <p class="advantage-description">
            En automatisant les tâches répétitives, nos solutions permettent à vos équipes de se concentrer
            sur des missions à forte valeur ajoutée tout en réduisant les coûts opérationnels. Les chatbots
            peuvent gérer simultanément des milliers de conversations, libérant ainsi vos ressources humaines
            pour traiter les cas les plus complexes.
          </p>
        </div>

        <!-- Avantage 3 -->
        <div class="advantage-card">
          <div class="advantage-number">3</div>
          <h3 class="advantage-title">Personnalisation et adaptabilité</h3>
          <p class="advantage-description">
            Chaque entreprise est unique. C'est pourquoi nous développons des chatbots qui s'intègrent
            parfaitement à vos systèmes existants, avec une interface adaptable à votre charte graphique
            et à vos processus métier. Nos solutions évoluent avec votre entreprise et s'adaptent aux
            changements de vos besoins.
          </p>
        </div>

        <!-- Avantage 4 -->
        <div class="advantage-card">
          <div class="advantage-number">4</div>
          <h3 class="advantage-title">Technologie de pointe enrichie par l'IA</h3>
          <p class="advantage-description">
            Grâce à l'intelligence artificielle et au machine learning, vos chatbots apprendront et s'amélioreront
            en continu, avec des discussions de plus en plus naturelles et pertinentes. Ils analyseront
            les conversations passées pour anticiper les besoins futurs et optimiser la qualité des réponses fournies.
          </p>
        </div>

        <!-- Avantage 5 -->
        <div class="advantage-card">
          <div class="advantage-number">5</div>
          <h3 class="advantage-title">Sécurité et conformité aux normes</h3>
          <p class="advantage-description">
            Nous mettons un point d'honneur à respecter les normes de sécurité et la protection des données,
            vous assurant une solution fiable et conforme aux réglementations en vigueur (RGPD, etc.).
            Vos données et celles de vos clients sont protégées par les protocoles de sécurité les plus avancés.
          </p>
        </div>

        <!-- Avantage 6 -->
        <div class="advantage-card">
          <div class="advantage-number">6</div>
          <h3 class="advantage-title">Analyses et rapports détaillés</h3>
          <p class="advantage-description">
            Vos chatbots fourniront des insights précieux sur les comportements et préférences de vos clients.
            Les données collectées vous permettront d'affiner votre stratégie commerciale, d'identifier les
            opportunités d'amélioration et de prendre des décisions basées sur des informations concrètes.
          </p>
        </div>
      </div>

      <!-- Cas concrets d'utilisation de l'IA -->
      <section class="card use-cases-card">
              <!-- Cas concrets d'utilisation de l'IA -->

              <div class="card-content">
                <h2 class="section-title">Dans quels domaines l'IA peut-elle concrètement bénéficier à votre entreprise ?</h2>
                <div class="text-and-illustration">
                  <div class="text-content">
                    <p>
                      L'IA ne reste pas dans le domaine théorique : elle se matérialise par des outils pratiques et qui améliorent le quotidien de manière concrète et mesurable. 
                      Voyez comment nos solutions augmentées par l'intelligence artificielle peuvent améliorer votre productivité de façon tangible.
                    </p>
                  </div>
                  <div class="ia-enterprise-illustration">
                    <img src="/img/cas-ia-entreprise.svg" alt="Applications concrètes de l'IA en entreprise" class="ia-enterprise-image" />
                  </div>
                </div>

                
                <div class="use-cases-grid">
                  <!-- Cas d'utilisation 1 : Service client et communication -->
                  <div class="use-case-card">
                    <div class="use-case-icon">
                      <span class="icon-placeholder">💬</span>
                    </div>
                    <h3 class="use-case-title">Service client et communication</h3>
                    <p class="use-case-description">
                      Avec nos chatbots intelligents, automatisez la gestion des questions courantes, répondez instantanément aux demandes de suivi ou aux questions fréquentes, réduisez les temps d'attente et libérez vos collaborateurs. Nos équipes d'agents IA vous servent d'assistants de rédaction et vous aident également à créer des emails professionnels et générer des synthèses de réunions. Ainsi, vous améliorez la qualité et la rapidité de la communication.
                    </p>
                  </div>
                  
                  <!-- Cas d'utilisation 2 : Optimisation des processus -->
                  <div class="use-case-card">
                    <div class="use-case-icon">
                      <span class="icon-placeholder">⚙️</span>
                    </div>
                    <h3 class="use-case-title">Optimisation des processus internes</h3>
                    <p class="use-case-description">
                      Automatisez les tâches répétitives comme la saisie et le traitement des données, la gestion des stocks ou le suivi des commandes. Utilisez nos systèmes d'IA qui analysent en temps réel les ventes pour déclencher automatiquement des réapprovisionnements et optimisent les itinéraires de livraison, réduisant les coûts de transport tout en améliorant la ponctualité.
                    </p>
                  </div>
                  
                  <!-- Cas d'utilisation 3 : Création de contenu et marketing -->
                  <div class="use-case-card">
                    <div class="use-case-icon">
                      <span class="icon-placeholder">📈</span>
                    </div>
                    <h3 class="use-case-title">Création de contenu et marketing</h3>
                    <p class="use-case-description">
                      Nos outils basés sur l'IA vous assistent dans la création de contenus marketing pertinents pour vos communications. Vous bénéficiez de textes optimisés pour vos flyers, affiches et publications sur les réseaux sociaux, respectant votre identité visuelle. Pour votre activité e-commerce, utilisez notre technologie pour analyser les comportements d'achat de vos clients afin de leur proposer des recommandations de produits personnalisées et d'améliorer vos taux de conversion.
                    </p>
                  </div>

                  <!-- Cas d'utilisation 4 : Ressources humaines et recrutement -->
                  <div class="use-case-card">
                    <div class="use-case-icon">
                      <span class="icon-placeholder">👥</span>
                    </div>
                    <h3 class="use-case-title">Ressources humaines et recrutement</h3>
                    <p class="use-case-description">
                      Gagnez du temps dans votre processus de recrutement avec nos systèmes d'IA. Ils vous permettent de trier les CV en quelques secondes pour identifier les profils correspondant le mieux aux postes à pourvoir. Vous pouvez également utiliser notre solution pour cartographier les compétences existantes dans votre entreprise, anticiper les besoins en formation et ainsi planifier efficacement le développement et l'évolution professionnelle de vos équipes.
                    </p>
                  </div>

                </div>

          <div class="metrics-banner">
            <div class="metric">
              <span class="metric-value">70%</span>
              <span class="metric-label">Réduction du temps de réponse client</span>
            </div>
            <div class="metric">
              <span class="metric-value">45%</span>
              <span class="metric-label">Baisse des coûts opérationnels</span>
            </div>
            <div class="metric">
              <span class="metric-value">25%</span>
              <span class="metric-label">Augmentation des conversions</span>
            </div>
          </div>
        </div>
      </section>

      <!-- Témoignages clients -->
      <section class="testimonials-section">
        <h2 class="testimonials-title">Ce que disent nos clients</h2>
        
        <div class="testimonials-container">
          <!-- Témoignage 1 -->
          <div class="testimonial-card">
            <div class="testimonial-header">
              <div class="client-info">
                <h3 class="client-name">Thomas L.</h3>
                <p class="client-company">Gérant d'une entreprise de logistique</p>
                <div class="rating">
                  <span>★</span><span>★</span><span>★</span><span>★</span><span>★</span>
                </div>
              </div>
            </div>
            <div class="testimonial-body">
              <p>Grâce à Arynae, nous avons réduit notre temps de réponse de 60% et augmenté
              la satisfaction client. Une solution innovante qui a transformé notre service après-vente.</p>
            </div>
            <div class="testimonial-border"></div>
          </div>
          
          <!-- Témoignage 2 -->
          <div class="testimonial-card">
            <div class="testimonial-header">
              <div class="client-info">
                <h3 class="client-name">Claire M.</h3>
                <p class="client-company">Gestionnaire de sinistres</p>
                <div class="rating">
                  <span>★</span><span>★</span><span>★</span><span>★</span><span>★</span>
                </div>
              </div>
            </div>
            <div class="testimonial-body">
              <p>Le chatbot conçu par leur équipe gère plus de 80% de nos demandes courantes, libérant nos conseillers
              pour les cas complexes. Notre ROI a été atteint en moins de 4 mois d'utilisation.</p>
            </div>
            <div class="testimonial-border"></div>
          </div>
          
          <!-- Témoignage 3 -->
          <div class="testimonial-card">
            <div class="testimonial-header">
              <div class="client-info">
                <h3 class="client-name">Raphaël D.</h3>
                <p class="client-company">Agent de voyages</p>
                <div class="rating">
                  <span>★</span><span>★</span><span>★</span><span>★</span><span>★</span>
                </div>
              </div>
            </div>
            <div class="testimonial-body">
              <p>L'intégration de notre assistant virtuel sur plusieurs canaux (web, WhatsApp, Messenger) nous 
              a permis d'être présents 24/7 pour nos clients, augmentant nos conversions de 35%.</p>
            </div>
            <div class="testimonial-border"></div>
          </div>
        </div>
        
        <div class="dots-navigation">
          <span class="dot active"></span>
          <span class="dot"></span>
          <span class="dot"></span>
        </div>
      </section>

      <!-- Call to action -->
      <div class="cta-container">
      <span class="cta-button fake-link" @click="navigateTo('e1')">Demandez une démonstration</span>
    </div>
    </div>
  </div>
</template>

<script>
import { useHead } from '@vueuse/head'

export default {
  name: 'ChatbotServicePage',
  setup() {
    useHead({
      title: 'Création de Chatbot - Solutions d\'IA conversationnelle | Arynae',
      meta: [
        { name: 'description', content: 'Développement de chatbots intelligents et d\'assistants virtuels sur mesure. Automatisez votre service client et améliorez l\'expérience utilisateur avec nos solutions d\'IA conversationnelle.' },
        { name: 'keywords', content: 'chatbot, assistant virtuel, IA conversationnelle, intelligence artificielle, service client automatisé, bot messenger, bot discord, bot whatsapp, Arynae' },
        { name: 'robots', content: 'index, follow' },
        { name: 'author', content: 'Arynae' },
        { 'http-equiv': 'Content-Type', content: 'text/html; charset=utf-8' },
        // Open Graph essentiels
        { property: 'og:type', content: 'website' },
        { property: 'og:title', content: 'Création de Chatbot - Solutions d\'IA conversationnelle | Arynae' },
        { property: 'og:description', content: 'Développement de chatbots intelligents et d\'assistants virtuels sur mesure. Automatisez votre service client et améliorez l\'expérience utilisateur avec nos solutions d\'IA conversationnelle.' },
        { property: 'og:url', content: 'https://arynae.com/chatbot' },
        { property: 'og:locale', content: 'fr_FR' },
        { property: 'og:image', content:'https://arynae.com/img/arynae-social-card.png' },
        { property: 'og:image:alt', content:'Agence digitale - Solutions No Code, SaaS, Chatbots & SEO' },

        // Twitter Card basiques
        { name: 'twitter:card', content: 'summary_large_image' },
        { name: 'twitter:title', content: 'Création de Chatbot - Solutions d\'IA conversationnelle | Arynae' },
        { name: 'twitter:description', content: 'Développement de chatbots intelligents et d\'assistants virtuels sur mesure. Automatisez votre service client et améliorez l\'expérience utilisateur avec nos solutions d\'IA conversationnelle.' },
        { name: 'twitter:image', content: 'https://arynae.com/img/arynae-social-card.png' },
        { name: 'viewport', content: 'width=device-width, initial-scale=1.0' }
      ],
      link: [
        { rel: 'canonical', href: 'https://arynae.com/chatbot' },
        { rel: 'alternate', hreflang: 'fr', href: 'https://arynae.com/chatbot' }
      ],
      htmlAttrs: {
        lang: 'fr'
      }
    })
    
    return {}
  },
  data() {
    return {}
  },
  methods: {
    navigateTo(code) {
      const routes = {
        'e1': 'https://cal.com/web-passion/rdv'
      };
      
      window.open(routes[code] || code, '_blank');
    }
  }
}
</script>

<style scoped>
.chatbot-page {
  font-family: Arial, sans-serif;
  color: #333;
}

/* Header Styles */
.header {
  background: linear-gradient(to right, #2563EB, #7C3AED);
  padding-bottom: 6rem;
  color: white;
}

.header-content {
  text-align: center;
  padding: 5rem 2rem 3rem;
}

.main-title {
  font-size: 2.75rem;
  margin-bottom: 1rem;
}

.subtitle {
  font-size: 1.25rem;
  max-width: 800px;
  margin: 0 auto;
}

/* Content Container */
.content-container {
  max-width: 1200px;
  margin: -3rem auto 4rem;
  padding: 0 2rem;
}

/* Card Styles */
.card {
  background: linear-gradient(to bottom, #ffffff, #f3f4f6);
  border-radius: 0.5rem;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
  margin-bottom: 2rem;
  overflow: hidden;
}

.card-content {
  padding: 2rem;
}

.section-title {
  font-size: 1.75rem;
  margin-bottom: 1.5rem;
  color: #333;
  display: block;
}

.text-content {
  font-size: 1rem;
  line-height: 1.6;
  color: #555;
}

/* Shared Flex Layout */
.text-and-illustration {
  display: flex;
  flex-wrap: wrap;
  gap: 2rem;
  align-items: center;
}

.text-and-illustration .text-content {
  flex: 2;
  min-width: 300px;
}

/* YouTube Container */
.youtube-container {
  flex: 1;
  min-width: 300px;
  height: 250px;
  display: flex;
  justify-content: center;
  align-items: center;
}

/* Chatbot Illustration */
.what-is-card .text-content {
  flex: 1.5;
  min-width: 300px;
}

.chatbot-illustration {
  flex: 1;
  min-width: 300px;
  max-width: 450px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.chatbot-image {
  max-width: 100%;
  height: auto;
  transform: scale(1.2);
}

/* Advantages Grid */
.advantages-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 2rem;
  margin: 3rem 0;
}

.advantage-card {
  background: white;
  border-radius: 0.5rem;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  padding: 2rem;
  position: relative;
}

.advantage-number {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 60px;
  height: 60px;
  border-radius: 50%;
  background: linear-gradient(to right, #2563EB, #7C3AED);
  color: white;
  font-size: 1.25rem;
  font-weight: bold;
  margin-bottom: 1rem;
}

.advantage-title {
  font-size: 1.25rem;
  margin-bottom: 1rem;
  color: #333;
}

.advantage-description {
  font-size: 0.875rem;
  line-height: 1.6;
  color: #555;
}

/* Use Cases Section */
.use-cases-card {
  margin-top: 3rem;
}

.use-cases-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 2rem;
  margin: 2.5rem 0;
}

.use-case-card {
  background: white;
  border-radius: 0.75rem;
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.08);
  padding: 1.5rem;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  border: 1px solid #f0f0f0;
}

.use-case-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 8px 15px rgba(0, 0, 0, 0.1);
}

.use-case-icon {
  width: 60px;
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 1rem;
  background: rgba(124, 58, 237, 0.1);
  border-radius: 50%;
  padding: 1rem;
}

.use-case-icon img {
  width: 100%;
  height: auto;
}

.use-case-title {
  font-size: 1.2rem;
  font-weight: 600;
  margin-bottom: 1rem;
  color: #333;
}

.use-case-description {
  font-size: 0.95rem;
  line-height: 1.6;
  color: #555;
}

/* Metrics Banner */
.metrics-banner {
  display: flex;
  justify-content: space-around;
  flex-wrap: wrap;
  gap: 2rem;
  background: linear-gradient(to right, rgba(37, 99, 235, 0.05), rgba(124, 58, 237, 0.05));
  border-radius: 0.75rem;
  padding: 2rem;
  margin-top: 2rem;
}

.metric {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
}

.metric-value {
  font-size: 2.5rem;
  font-weight: 700;
  margin-bottom: 0.5rem;
  background: linear-gradient(to right, #2563EB, #7C3AED);
  background-clip: text;
  -webkit-background-clip: text;
  color: transparent;
  -webkit-text-fill-color: transparent;
}

.metric-label {
  font-size: 1rem;
  color: #4B5563;
}

/* Testimonials Section */
.testimonials-section {
  padding: 5rem 0;
  background: #ffffff;
  margin: 5rem 0;
  position: relative;
  overflow: hidden;
}

.testimonials-section::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: radial-gradient(circle at 10% 20%, rgba(37, 99, 235, 0.05) 0%, rgba(124, 58, 237, 0.05) 90%);
  z-index: 0;
}

.testimonials-title {
  font-size: 2.5rem;
  font-weight: 800;
  text-align: center;
  margin-bottom: 4rem;
  color: #1a202c;
  position: relative;
  z-index: 1;
}

.testimonials-title::after {
  content: "";
  position: absolute;
  bottom: -15px;
  left: 50%;
  transform: translateX(-50%);
  width: 80px;
  height: 4px;
  background: linear-gradient(90deg, #2563EB, #7C3AED, #EC4899);
  border-radius: 2px;
}

.testimonials-container {
  display: flex;
  gap: 2rem;
  padding: 1rem 4rem;
  max-width: 1400px;
  margin: 0 auto;
  position: relative;
  z-index: 1;
  overflow-x: auto;
  scrollbar-width: none;
  scroll-snap-type: x mandatory;
  -webkit-overflow-scrolling: touch;
}

.testimonials-container::-webkit-scrollbar {
  display: none;
}

.testimonial-card {
  background: white;
  border-radius: 16px;
  min-width: 320px;
  flex: 1;
  position: relative;
  scroll-snap-align: center;
  transition: all 0.3s ease;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.04), 0 0 8px rgba(0, 0, 0, 0.06);
  overflow: hidden;
  display: flex;
  flex-direction: column;
  padding: 0;
}

.testimonial-card:hover {
  transform: translateY(-8px);
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.08), 0 0 12px rgba(0, 0, 0, 0.06);
}

.testimonial-header {
  display: flex;
  align-items: center;
  padding: 1.5rem 1.5rem 0.5rem;
}

.client-info {
  flex: 1;
}

.client-name {
  font-size: 1.25rem;
  font-weight: 700;
  margin: 0 0 0.25rem;
  color: #1a202c;
}

.client-company {
  font-size: 0.9rem;
  color: #718096;
  margin: 0 0 0.5rem;
}

.rating {
  display: flex;
  font-size: 1.1rem;
  color: #FFC107;
}

.testimonial-body {
  padding: 0.5rem 1.5rem 2rem;
  font-size: 1rem;
  line-height: 1.7;
  color: #4A5568;
  flex: 1;
}

.testimonial-border {
  height: 5px;
  background: linear-gradient(90deg, #2563EB, #7C3AED, #EC4899);
  width: 100%;
}

.dots-navigation {
  display: flex;
  justify-content: center;
  gap: 0.5rem;
  margin-top: 2.5rem;
}

.dot {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background-color: #CBD5E0;
  cursor: pointer;
  transition: all 0.3s ease;
}

.dot:hover {
  background-color: #A0AEC0;
}

.dot.active {
  background: linear-gradient(90deg, #2563EB, #7C3AED);
  width: 30px;
  border-radius: 10px;
}

/* Testimonials Section - Correction responsive */
.testimonials-container {
  display: flex;
  flex-direction: row;
  gap: 2rem;
  padding: 1rem;
  max-width: 100%;
  margin: 0 auto;
  position: relative;
  z-index: 1;
  overflow-x: auto;
  padding-bottom: 1rem; /* Espace pour la scrollbar */
}

.testimonial-card {
  flex: 0 0 calc(33.333% - 1.5rem);
  min-width: 280px;
  background: white;
  border-radius: 16px;
  position: relative;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.04), 0 0 8px rgba(0, 0, 0, 0.06);
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

/* Cache la scrollbar sur certains navigateurs mais garde la fonctionnalité */
.testimonials-container::-webkit-scrollbar {
  height: 6px;
}

.testimonials-container::-webkit-scrollbar-thumb {
  background-color: rgba(0, 0, 0, 0.2);
  border-radius: 3px;
}

.testimonials-container::-webkit-scrollbar-track {
  background-color: rgba(0, 0, 0, 0.05);
}

@media (max-width: 768px) {
  .testimonials-container {
    padding-left: 1rem;
    padding-right: 1rem;
  }
}

.dots-navigation {
  display: none;
}

.dots-navigation {
  display: none; /* Cache les points s'ils ne sont pas nécessaires */
}

@media (max-width: 992px) {
  .testimonials-container {
    flex-direction: column;
    padding: 1rem;
    gap: 2rem;
  }
  
  .testimonial-card {
    width: 100%;
    margin-bottom: 1rem;
  }
}

.client-name {
  font-weight: bold;
  font-style: normal;
  margin-top: 1rem;
}

/* Call to Action */
.cta-container {
  text-align: center;
  margin: 3rem 0;
}

.cta-button {
  background: linear-gradient(to right, #2563EB, #7C3AED);
  color: white;
  font-size: 1.25rem;
  font-weight: bold;
  padding: 1rem 2.5rem;
  border: none;
  border-radius: 2rem;
  cursor: pointer;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.cta-button:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.25);
}

/* Responsive Adjustments */
@media (max-width: 768px) {
  /* Header */
  .header-content {
    padding: 4rem 1rem 2rem;
  }
  
  .main-title {
    font-size: 2rem;
  }
  
  .content-container {
    padding: 0 1rem;
  }
  
  /* Grids */
  .advantages-grid,
  .use-cases-grid {
    grid-template-columns: 1fr;
  }
  
  /* Layout */
  .text-and-illustration {
    flex-direction: column;
  }
  
  .youtube-container {
    height: 200px;
  }
  
  /* Chatbot */
  .what-is-card .text-and-illustration {
      flex-direction: column;
      align-items: center;
    }
    
    .what-is-card .text-content {
      width: 100%;
      min-width: 100%;
      order: 1;
    }
    
    .chatbot-illustration {
      width: 100%;
      min-width: 100%;
      max-width: 80%;
      margin-top: 1.5rem;
      order: 2;
    }
    
    .what-is-card .section-title {
      font-size: 1.5rem;
      text-align: center;
    }
  
  .chatbot-image {
    transform: scale(1.3);
  }
  
  /* Intro Card - Fix pour la section introduction */
  .intro-card .text-and-illustration {
      flex-direction: column;
    }
    
    .intro-card .text-content {
      width: 100%;
      min-width: 100%;
      margin-bottom: 1rem;
    }
    
    .intro-card .youtube-container {
      width: 100%;
      min-width: 100%;
      margin-top: 1rem;
    }
    
    .intro-card .section-title {
      font-size: 1.5rem;
      text-align: center;
    }
  
  /* Testimonials */
  .testimonials-container {
    padding: 1rem;
    flex-direction: column;
    gap: 2rem;
  }
  
  .testimonial-card {
    min-width: 100%;
  }
  
  .testimonials-title {
    font-size: 2rem;
    margin-bottom: 2.5rem;
  }
  
  /* Metrics */
  .metrics-banner {
    flex-direction: column;
    gap: 1.5rem;
  }
}

/* IA Enterprise Illustration */
.ia-enterprise-illustration {
  flex: 1;
  min-width: 450px;
  max-width: 500px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.ia-enterprise-image {
  max-width: 100%;
  height: auto;
}

@media (max-width: 768px) {
  .ia-enterprise-illustration {
    min-width: 100%;
    margin-top: 1.5rem;
  }
}

</style>